
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FilePlus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const EmptyState = () => {
  const navigate = useNavigate();
  
  return (
    <Card className="border">
      <CardContent className="flex flex-col items-center justify-center py-8 text-center">
        <div className="bg-primary/10 p-3 rounded-full mb-4">
          <FilePlus className="h-6 w-6 text-primary" />
        </div>
        <h3 className="text-lg font-medium mb-2">No applications yet</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Start your PEO application process to find the best providers for your business.
        </p>
        <Button 
          onClick={() => navigate('/application')}
          className="mt-2"
        >
          Start New Application
        </Button>
      </CardContent>
    </Card>
  );
};
